import * as Error from '../../../Previewer/utils/error';
import { annotationEventOptions, viewerEventOptions } from './options';
import { LINK_TO_SDK, SCRIPT_TAG_SDK_ID, VIEW_OPTIONS } from './constants';

const featureFlags = {
    showAnnotationTools: true,
    enableAnnotationAPIs: true,
    includePDFAnnotations: false,
    showDisabledSaveButton: true,
    showPageControls: true,
    dockPageControls: false,
    showDownloadPDF: false,
    showPrintPDF: false,
    defaultViewMode: VIEW_OPTIONS.FIT_WIDTH,
    enableFormFilling: false,
    enableSearchAPIs: true
};

const customFlags = {
    showToolbar: false,
    showCommentsPanel: false,
    downloadWithAnnotations: false,
    showToolsOnTextSelection: true,
    printWithAnnotations: false
};

export const addScriptTagSDK = (onLoadCallback, onErrorCallback) => {
    const sdkScriptTag = document.getElementById(SCRIPT_TAG_SDK_ID);
    if (sdkScriptTag) {
        removeScriptTagSDK();
    }
    const script = document.createElement('script');
    script.src = LINK_TO_SDK;
    script.type = 'application/javascript';
    script.id = SCRIPT_TAG_SDK_ID;
    script.onload = () => {
        if (typeof onLoadCallback === 'function'){
            onLoadCallback();
        }
    };
    script.onerror = (err) => {
        Error.send(err, 'PDF: Adobe embed sdk: failed to load in script tag');
        if (typeof onErrorCallback === 'function') {
            onErrorCallback(err);
        }
    };
    document.body.appendChild(script);
};

export const removeScriptTagSDK = () => {
    const sdkScriptTag = document.getElementById(SCRIPT_TAG_SDK_ID);
    sdkScriptTag?.parentNode.removeChild(sdkScriptTag);
};

export const createAdobeViewer = (adobeDCView, url, fileName, fileId) => adobeDCView.previewFile({
    content: {
        location: { url }
    },
    metaData: { fileName, id: fileId }
},
featureFlags, { embedMode: 'SIZED_CONTAINER' });

export const removeSaveButton = (AdobeDC, adobeDCView) => {
    adobeDCView.registerCallback(
        AdobeDC.View.Enum.CallbackType.SAVE_API,
        () => Promise.resolve({ code: AdobeDC.View.Enum.ApiResponseCode.SUCCESS }),
        { showSaveButton: false }
    );
};

export const setConfig = (annotationManager, overideFlags = customFlags) => annotationManager.setConfig({
    ...customFlags,
    ...overideFlags
});

export const registerViewerEvents = (AdobeDC, adobeDCView, callback) => {
    adobeDCView.registerCallback(
        AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
        (event) => callback(event), viewerEventOptions
    );
};

export const registerAnnotationEvents = (annotationManager, callback) => {
    annotationManager.registerEventListener(
        (event) => callback(event), annotationEventOptions
    );
};
